import { getHeaders } from '../../core/actions/xhrRequest';
import { createAction } from 'redux-api-middleware';

export const SET_PREFERRED_WRITER_RATIO = 'SET_PREFERRED_WRITER_RATIO';
export const GET_ORDER_OPTION_INIT = 'GET_ORDER_OPTION_INIT';
export const GET_ORDER_OPTION_SUCCESS = 'GET_ORDER_OPTION_SUCCESS';
export const GET_ORDER_OPTION_FAILURE = 'GET_ORDER_OPTION_FAILURE';

export const setPreferredWriterRatio = ratio => ({
    type: SET_PREFERRED_WRITER_RATIO,
    payload: ratio,
})

export const getOrderOptions = () => createAction({
    types: [
        GET_ORDER_OPTION_INIT,
        GET_ORDER_OPTION_SUCCESS,
        GET_ORDER_OPTION_FAILURE
    ],
    endpoint: `/api/order-dictionary/order-option`,
    headers: getHeaders(),
    method: 'GET',
    credentials: 'include'
})